import { useMemo } from 'react';
import { BudgetStatusEnum } from '../../../../enums/budgetStatus';
import { BudgetRecipientEnum } from '../../createAndEdit/types';
import { Budget } from '../../types';

interface IUseBudgetViewModeParams {
  lastVersionNumber?: number;
  budget?: Budget;
  userProfile?: BudgetRecipientEnum | string;
  versionNumber?: number;
}

export type BudgetViewMode = 'detail' | 'update' | 'create';

export const useBudgetViewMode = (params: IUseBudgetViewModeParams): BudgetViewMode => {
  const { budget, userProfile, versionNumber, lastVersionNumber } = params;

  return useMemo(() => {
    if (!budget) {
      return 'create';
    }

    const currentVersion = versionNumber || lastVersionNumber || budget.version;
    const lastVersion = lastVersionNumber || budget.lastVersionNumber;
    const isLastVersion = currentVersion === lastVersion;

    if (!isLastVersion) {
      return 'detail';
    }

    const status = budget.status;
    const recipient = budget.recipient as BudgetRecipientEnum | string;

    const isApprovedByManager = status === BudgetStatusEnum.APPROVED || status === 'Aprovado';

    if (isApprovedByManager) {
      return 'detail';
    }

    if (recipient === BudgetRecipientEnum.MANAGER || recipient === 'MANAGER') {
      return 'detail';
    }

    if (
      recipient === BudgetRecipientEnum.CONSULTANT || recipient === 'CONSULTANT' ||
      recipient === BudgetRecipientEnum.TOWER || recipient === 'FACTORY' || recipient === 'TOWER'
    ) {
      const recipientStr = String(recipient);
      const userProfileStr = userProfile ? String(userProfile) : '';
      
      const normalizedRecipient = 
        recipientStr === 'FACTORY' || recipientStr === 'TOWER' || recipientStr === BudgetRecipientEnum.TOWER
          ? BudgetRecipientEnum.TOWER
          : recipientStr === 'CONSULTANT' || recipientStr === BudgetRecipientEnum.CONSULTANT
          ? BudgetRecipientEnum.CONSULTANT
          : recipientStr;
      
      const normalizedUserProfile = 
        userProfileStr === 'FACTORY' || userProfileStr === 'TOWER' || userProfileStr === BudgetRecipientEnum.TOWER
          ? BudgetRecipientEnum.TOWER
          : userProfileStr === 'CONSULTANT' || userProfileStr === BudgetRecipientEnum.CONSULTANT
          ? BudgetRecipientEnum.CONSULTANT
          : userProfileStr;
      
      if (normalizedRecipient !== normalizedUserProfile) {
        return 'detail';
      }

      return 'update';
    }

    return 'detail';
  }, [budget, userProfile, versionNumber, lastVersionNumber]);
};

